import { render, staticRenderFns } from "./RespostasCandidato.vue?vue&type=template&id=38dd4cbd"
import script from "./RespostasCandidato.vue?vue&type=script&lang=js"
export * from "./RespostasCandidato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports